import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import Searchbar from "../../components/searchBar/Searchbar";
import style from "./GrupoDeUsuario.module.css";
import { Link } from "react-router-dom";
import { MdDelete, MdEdit, MdSearch, MdClose } from "react-icons/md";
import GrupoDeUsuarioApi from "../../services/GrupoDeUsuarioApi";
import { useEffect, useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import Alerta from "../../components/alerta/Alerta";
import BotaoNovo from "../../components/botaoNovo/BotaoNovo";
import Paginacao from "../../components/paginacao/Paginacao";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";



function GrupoDeUsuario() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);
  const [GrupoDeUsuarios, setGrupoDeUsuarios] = useState([]);
  const [search, setSearch] = useState("");
  const [GrupoDeUsuarioSelecionado, setGrupoDeUsuarioSelecionado] =
    useState(null);


  //Para rodar a tabela, paginação e filtro
  const [grupoUsuarios, setGrupoUsuarios] = useState([]);

  const [quantidadeItens, setQuantidadeItens] = useState(0);
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [nomeFiltro, setNomeFiltro] = useState("");
  const [descricaoFiltro, setDescricaoFiltro] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);


  // const [paginaAtual, setpaginaAtual] = useState(1); // Estado inicial da página
  const [itensPorPagina] = useState(5); // Define o número de itens por página

  const [mostarModalDeletar, setMostarModalDelatar] = useState(false);
  const [mostarModalEditar, setMostarModalEditar] = useState(false);

  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [loading, setLoading] = useState(false);


  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 2000);
  };

  //Função para filtro de busca
  async function BuscarGrupoDeUsuarios() {
    setNome(nomeFiltro);
    setDescricao(descricaoFiltro);
    setPaginaAtual(1);
    await CarregarGrupoDeUsuariosPaginacao(1, nomeFiltro, descricaoFiltro);
  }

  //Função para resetar  filtro de busca
  async function ResetarGrupoDeUsuarios() {
    setNome("");
    setDescricao("");
    setNomeFiltro("");
    setDescricaoFiltro("");
    setPaginaAtual(1);
    CarregarGrupoDeUsuariosPaginacao(1, "", "");
  }

  //Função para carregar os avisos
  async function CarregarGrupoDeUsuariosPaginacao(paginaAtual, nome, descricao) {
    try {
      const listaGrupos = await GrupoDeUsuarioApi.ListarGrupoDeUsuariosComPaginacaoAsync(
        paginaAtual,
        nome,
        descricao
      );
      setQuantidadeItens(listaGrupos.quantidadeRegistros);
      setGrupoUsuarios(listaGrupos.registros);
    } catch (error) {
      console.error("Erro ao carregar grupo de usuários:", error.response.data);
    }
  }
  async function AlterarPagina(paginaNova) {
    setPaginaAtual(paginaNova);
    await CarregarGrupoDeUsuariosPaginacao(paginaNova, nome, descricao);
  }



  const handleClickDeletar = (GrupoDeUsuario) => {
    setGrupoDeUsuarioSelecionado(GrupoDeUsuario);

    setMostarModalDelatar(true);
  };

  const handleEditar = async () => {
    try {
      setLoading(true);
      await GrupoDeUsuarioApi.AtualizarGrupoDeUsuarioAsync(
        GrupoDeUsuarioSelecionado.id,
        GrupoDeUsuarioSelecionado.nome,
        GrupoDeUsuarioSelecionado.descricao
      );
      setMensagemAlerta(`Grupo de usuário atualizado com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta();
    } catch (error) {
      console.error("Erro ao atualizar o grupo de usuário:", error);
    } finally {
      handleFecharModal();
      setLoading(false);
    }
  };

  const handleDeletar = async () => {
    try {
      setLoading(true);
      await GrupoDeUsuarioApi.DeletarGrupoDeUsuarioAsync(
        GrupoDeUsuarioSelecionado.grupoDeUsuarioId
      );

      await CarregarGrupoDeUsuariosPaginacao();

      setMensagemAlerta(`Grupo de usuário deletado com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta();
    } catch (error) {
      setMensagemAlerta(
        `Erro ao deletar Grupo de usuário: ${error.response.data}`
      );
      setTipoAlerta("danger");
      exibirAlerta();

    } finally {
      handleFecharModal();
      setLoading(false);
    }
  };

  const handleFecharModal = () => {
    setMostarModalDelatar(false);
    setMostarModalEditar(false);
    setGrupoDeUsuarioSelecionado(null);
  };


  useEffect(() => {
    CarregarGrupoDeUsuariosPaginacao(paginaAtual, nome, descricao);
  }, [paginaAtual, nome, descricao]);

  const totalPages = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar

        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}

      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          {/* Cabeçalho da página */}
          <div className={style.container_cabecalho}>
            <h4>Grupo de Usuários</h4>
            <BotaoNovo link={"/backoffice/GrupoDeUsuario/novo"} />
          </div>

          {/* Filtro de pesquisa */}
          <div className={style.container_filtro}>
            <InputBuscar
              type="text"
              id="hidenNome"
              placeholder="Nome"
              name="nome"
              maxLength={30}
              value={nomeFiltro}
              onChange={(e) => setNomeFiltro(e.target.value)}
            />

            <InputBuscar
              type="text"
              id="hidenDescricao"
              placeholder="Descrição"
              name="descricao"
              maxLength={70}
              value={descricaoFiltro}
              onChange={(e) => setDescricaoFiltro(e.target.value)}
            />
            <div className={style.container_filtro2}>

              <Button onClick={BuscarGrupoDeUsuarios} id={style.botao_buscar}><MdSearch /> Buscar
              </Button>

              <Button onClick={ResetarGrupoDeUsuarios} id={style.botao_resetar}><MdClose /> Limpar
              </Button>
            </div>

          </div>

          <div className={style.container_tabela_paginacao}>
            {/* Tabela*/}
            <div className={style.tabela_responsiva}>
              <table className={style.container_tabela}>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Descrição</th>
                    <th className={style.coluna_acoes}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {grupoUsuarios.map((GrupoDeUsuario) => (
                    <tr key={GrupoDeUsuario.grupoDeUsuarioId}>
                      <td title={GrupoDeUsuario.nome}>{GrupoDeUsuario.nome}</td>
                      <td title={GrupoDeUsuario.descricao}>{GrupoDeUsuario.descricao}</td>
                      <td className={style.coluna_acoes}>
                        <Link
                          to="/backoffice/Permissoes"
                          state={{ id: GrupoDeUsuario.grupoDeUsuarioId, nome: GrupoDeUsuario.nome }}
                          className={style.botao_editar}
                        >
                          <MdEdit
                            title="Editar" />
                        </Link>
                        <Link
                          onClick={() => handleClickDeletar(GrupoDeUsuario)}
                          className={style.botao_deletar}
                        >
                          <MdDelete
                            title="Deletar" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Controle de Paginação */}
            <Paginacao
              paginaAtual={paginaAtual}
              totalPages={totalPages}
              onPageChange={(novaPagina) => setPaginaAtual(novaPagina)}
            />
          </div>

          {/* Modal de confirmação */}
          <Modal show={mostarModalDeletar} onHide={handleFecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Confirmar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Tem certeza que deseja deletar o grupo{" "}
              {GrupoDeUsuarioSelecionado?.nome}?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleFecharModal}>
                Cancelar
              </Button>
              <Button variant="danger" onClick={handleDeletar}>
                Deletar
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal de edição */}
          <Modal show={mostarModalEditar} onHide={handleFecharModal}>
            <Modal.Header closeButton>
              <Modal.Title>Editar Grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="formNome" className="mb-3">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite seu nome"
                    name="nome"
                    value={GrupoDeUsuarioSelecionado?.nome || ""}
                    onChange={(e) =>
                      setGrupoDeUsuarioSelecionado({
                        ...GrupoDeUsuarioSelecionado,
                        [e.target.name]: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
                <Form.Group controlId="formDescricao" className="mb-3">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Descrição"
                    name="descricao"
                    value={GrupoDeUsuarioSelecionado?.descricao || ""}
                    onChange={(e) =>
                      setGrupoDeUsuarioSelecionado({
                        ...GrupoDeUsuarioSelecionado,
                        [e.target.name]: e.target.value,
                      })
                    }
                    required
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleFecharModal}>
                Cancelar
              </Button>
              <Button variant="danger" onClick={handleEditar}>
                Atualizar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default GrupoDeUsuario;
